import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import * as Quotes from '../slices/quotesSlice';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { AnyAction } from 'redux';
import NavBar from './navbar';

const LoadQuote = () => {
	const quotes = useAppSelector(state => state.quotes);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(Quotes.getQuote((quotes.quote.quoteid)) as unknown as AnyAction).then(() => {
			navigate('/quote');
		});
	}, []);

	return (
		<div>
			<NavBar />
			<div className="centered" style={{ display: 'flex', flexDirection: 'column' }}>
				<div style={{ fontFamily: 'kanitbold' }}>LOADING QUOTE</div>
				<img src={require('../assets/bricks.gif')} alt='Bricks-Gif' style={{ width: 67, height: 34 }} />
			</div>
		</div>
	);
}

export default LoadQuote;